import {
  CREATE_CUSTOMER_PENDING,
  CREATE_CUSTOMER_FULFILLED,
  CREATE_CUSTOMER_REJECTED,
  LOGIN_CUSTOMER_PENDING,
  LOGIN_CUSTOMER_FULFILLED,
  LOGIN_CUSTOMER_REJECTED,
  LOGOUT_CUSTOMER,
  ADD_NEW_ADDRESS_PENDING,
  ADD_NEW_ADDRESS_FULFILLED,
  ADD_NEW_ADDRESS_REJECTED,
  GET_ADDRESS_PENDING,
  GET_ADDRESS_FULFILLED,
  GET_ADDRESS_REJECTED,
  GET_PROFILE_INFO_PENDING,
  GET_PROFILE_INFO_FULFILLED,
  GET_PROFILE_INFO_REJECTED,
  UPDATE_PROFILE_PENDING,
  UPDATE_PROFILE_FULFILLED,
  UPDATE_PROFILE_REJECTED,
  UPDATE_PASSWORD_PENDING,
  UPDATE_PASSWORD_FULFILLED,
  UPDATE_PASSWORD_REJECTED,
  UPDATE_ADDRESS_ACTIVE_PENDING,
  UPDATE_ADDRESS_ACTIVE_FULFILLED,
  UPDATE_ADDRESS_ACTIVE_REJECTED,
  REMOVE_ADDRESS_PENDING,
  REMOVE_ADDRESS_FULFILLED,
  REMOVE_ADDRESS_REJECTED,
  FORGOT_PASSWORD_PENDING,
  FORGOT_PASSWORD_FULFILLED,
  FORGOT_PASSWORD_REJECTED,
  RESET_PASSWORD_PENDING,
  RESET_PASSWORD_FULFILLED,
  RESET_PASSWORD_REJECTED,
  EDIT_ADDRESS_PENDING,
  EDIT_ADDRESS_FULFILLED,
  EDIT_ADDRESS_REJECTED
} from "../actions/customer";

const initialState = {
  fetching: false,
  addressFetching: false,
  customer: null,
  addresses: [],
  errors: [],
  profile: null,
  profileFetching: false,
  forgotFetching: false,
  forgotError: null,
  forgot: null,
  resetPasswordFetching: false,
  resetPasswordError: null,
  resetPassword: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_PENDING:
      return {
        ...state,
        resetPasswordFetching: true
      };
    case RESET_PASSWORD_FULFILLED:
      return {
        ...state,
        resetPassword: action.payload,
        resetPasswordError: null,
        resetPasswordFetching: false
      };
    case RESET_PASSWORD_REJECTED:
      return {
        ...state,
        resetPasswordError: action.payload,
        resetPasswordFetching: false
      };

    case FORGOT_PASSWORD_PENDING:
      return {
        ...state,
        forgotFetching: true
      };
    case FORGOT_PASSWORD_FULFILLED:
      return {
        ...state,
        forgot: action.payload,
        forgotError: null,
        forgotFetching: false
      };
    case FORGOT_PASSWORD_REJECTED:
      return {
        ...state,
        forgotError: action.payload,
        forgotFetching: false
      };

    case REMOVE_ADDRESS_PENDING:
      return {
        ...state,
        addressFetching: true
      };
    case REMOVE_ADDRESS_FULFILLED:
      return {
        ...state,
        addressFetching: false,
        addresses: action.payload
      };
    case REMOVE_ADDRESS_REJECTED:
      return {
        ...state,
        addressFetching: false
      };
    case UPDATE_ADDRESS_ACTIVE_PENDING:
      return {
        ...state,
        addressFetching: true
      };
    case UPDATE_ADDRESS_ACTIVE_FULFILLED:
      return {
        ...state,
        addressFetching: false,
        addresses: action.payload
      };
    case UPDATE_ADDRESS_ACTIVE_REJECTED:
      return {
        ...state,
        addressFetching: false
      };

    case UPDATE_PASSWORD_PENDING:
      return {
        ...state,
        profileFetching: true
      };
    case UPDATE_PASSWORD_FULFILLED:
      return {
        ...state,
        profileFetching: false
      };
    case UPDATE_PASSWORD_REJECTED:
      return {
        ...state,
        profileFetching: false
      };
    case UPDATE_PROFILE_PENDING:
      return {
        ...state,
        profileFetching: true
      };
    case UPDATE_PROFILE_FULFILLED:
      return {
        ...state,
        profile: action.payload,
        profileFetching: false
      };
    case UPDATE_PROFILE_REJECTED:
      return {
        ...state,
        profileFetching: false
      };
    case GET_PROFILE_INFO_PENDING:
      return {
        ...state,
        profileFetching: true
      };
    case GET_PROFILE_INFO_FULFILLED:
      return {
        ...state,
        profileFetching: false,
        profile: action.payload
      };
    case GET_PROFILE_INFO_REJECTED:
      return {
        ...state,
        profileFetching: false
      };

    case EDIT_ADDRESS_PENDING:
      return {
        ...state,
        addressFetching: true
      };
    case EDIT_ADDRESS_FULFILLED:
      return {
        ...state,
        addressFetching: false,
        addresses: action.payload
      };
    case EDIT_ADDRESS_REJECTED:
      return {
        ...state,
        addressFetching: false
      };

    case ADD_NEW_ADDRESS_PENDING:
      return {
        ...state,
        addressFetching: true
      };
    case ADD_NEW_ADDRESS_FULFILLED:
      return {
        ...state,
        addressFetching: false,
        addresses: action.payload
      };
    case ADD_NEW_ADDRESS_REJECTED:
      return {
        ...state,
        addressFetching: false
      };

    case GET_ADDRESS_PENDING:
      return {
        ...state,
        addressFetching: true
      };
    case GET_ADDRESS_FULFILLED:
      return {
        ...state,
        addressFetching: false,
        addresses: action.payload
      };
    case GET_ADDRESS_REJECTED:
      return {
        ...state,
        addressFetching: false
      };
    case CREATE_CUSTOMER_PENDING:
      return {
        ...state,
        fetching: true
      };
    case CREATE_CUSTOMER_FULFILLED:
      return {
        ...state,
        errors: [],
        customer: action.payload,
        fetching: false
      };
    case CREATE_CUSTOMER_REJECTED:
      return {
        ...state,
        fetching: false,
        errors: action.payload
      };

    case LOGIN_CUSTOMER_PENDING:
      return {
        ...state,
        fetching: true
      };
    case LOGIN_CUSTOMER_FULFILLED:
      return {
        ...state,
        errors: [],
        customer: action.payload,
        fetching: false
      };
    case LOGIN_CUSTOMER_REJECTED:
      return {
        ...state,
        fetching: false,
        errors: action.payload
      };
    case LOGOUT_CUSTOMER:
      return {
        ...state,
        customer: null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/customerReducer.js